import { put, call, take, fork } from 'redux-saga/effects'
import { courseSettingPatchByIdService } from '../../api/course'
import { courseSettingPatchByIdSuccess } from '../../reducers/course/action'
import { COURSE_SETTING_PATCH_BY_ID } from '../../reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* courseSettingPatchByIdFlow(payload) {
  try {
    const { courseId, settingId, data, callback } = payload

    const response = yield call(
      courseSettingPatchByIdService,
      courseId,
      settingId,
      data,
    )
    // Pass the full response data (not the request data) so the course state gets updated
    yield put(courseSettingPatchByIdSuccess(courseId, settingId, response.data))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* courseSettingPatchByIdWatcher() {
  while (true) {
    const action = yield take(COURSE_SETTING_PATCH_BY_ID)
    const { payload } = action

    yield fork(generalSaga, courseSettingPatchByIdFlow, payload, false)
  }
}
